import { interfaceConstants } from '../_constants';

export function secteurs(state = {}, action) {
  switch (action.type) { 
     case interfaceConstants.SECTEURS_REQUEST:
      return {
        loading: true
      };
    case interfaceConstants.SECTEURS_SUCCESS:

    
      return {
        items: action.secteurs
      };
    case interfaceConstants.SECTEURS_FAILURE:
      return { 
        error: action.error
      };
    default:
      return state
  }
}